import { ServiceMaker, methods, services } from "../services";


export const createSubscriptionplan = payload =>
    ServiceMaker(`/subscription`, methods.POST, services.subscriptionpayments, payload);

export const subscriptionplanList = payload =>
ServiceMaker(`/subscription`, methods.GET, services.subscriptionpayments);

export const editSubscription = payload =>
ServiceMaker(
    `/subscription/${payload.id}`,
    methods.PATCH,
    services.subscriptionpayments,
    payload.data
  );
   